import _ from 'lodash'
import * as React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Autocomplete as AutocompleteMUI } from '@mui/material'
import Textfield from '../FormsUI/Textfield'
import * as service from '../../services'
import {
  saveTemporaryOptionsSpecie,
  setEnableSpecieField,
} from '../../redux/slices/Tree/treeFeatures'

const MSJ_ERROR = { error: true, helperText: 'Obligatorio' }

const InputGroup1 = ({ name, options, editable, ...rest }) => {
  const dispatch = useDispatch()
  const valuesOptions = Object.values(options)
  const sortedOptionsList = valuesOptions.sort()
  const tOptionsSpecie = useSelector(state => state.treeFeatures.temporaryOptionsSpecie)
  const specieField = useSelector(
    state => state.treeFeatures.enableSaveButton.specieField
  )

  const optionsListInitial = _.map(sortedOptionsList, label => ({
    id: _.findKey(options, val => val === label),
    name,
    label: label,
  }))

  const lastItem = _.remove(optionsListInitial, obj => obj.id === '#')
  if (Boolean(lastItem.length)) optionsListInitial.push(lastItem[0])

  const initialSelectedList = Boolean(rest.initvalue)
    ? _.find(optionsListInitial, ['id', `${rest.initvalue}`])
    : null
  const [filterList1, setSelectedList] = React.useState(initialSelectedList)

  const optionsList = name === 'family_' ? optionsListInitial : tOptionsSpecie

  function isInOptions() {
    return tOptionsSpecie ? _.some(tOptionsSpecie, ['id', filterList1.id]) : true
  }

  const othersProps = {
    name,
    value: filterList1?.id ?? '',
    label: rest.label,
    variant: 'standard',
    error: name === 'specie_' ? specieField.error : undefined,
    helperText: name === 'specie_' ? specieField.helperText : undefined,
  }

  const handleSelection = async (event, newList) => {
    setSelectedList(newList)
    if (name === 'family_') {
      let opts = null
      if (Boolean(newList)) {
        const familyId = newList.id
        const response = await service.getSpeciesByFamilyId(familyId)
        opts = _.map(response, o => ({
          id: o?.id_e?.toString(),
          name,
          label: o?.nombre_cientifico,
        }))
      }
      dispatch(saveTemporaryOptionsSpecie(opts))
    }
  }

  const handleOnBlur = () => {
    if (name === 'specie_')
      if (!specieField.error && !Boolean(filterList1?.label?.length))
        dispatch(setEnableSpecieField(MSJ_ERROR))
  }

  const getOptionDisabled = options => options?.id === '#'

  React.useEffect(() => {
    if (name !== 'specie_') return
    let validatorInput = { error: false, selected: filterList1 }
    if (!Boolean(filterList1)) validatorInput = MSJ_ERROR
    else if (!isInOptions()) setSelectedList(null)
    if (tOptionsSpecie || Boolean(filterList1))
      dispatch(setEnableSpecieField(validatorInput))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterList1, tOptionsSpecie])

  React.useEffect(() => {
    return () => {
      const MSJ_DEFAULT = { error: false, selected: null }
      dispatch(setEnableSpecieField(MSJ_DEFAULT))
      dispatch(saveTemporaryOptionsSpecie(null))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <AutocompleteMUI
      id={`update-${name}`}
      name={name}
      value={filterList1}
      onChange={handleSelection}
      onBlur={handleOnBlur}
      options={optionsList ?? optionsListInitial}
      noOptionsText="Opción no válida"
      readOnly={!editable}
      getOptionLabel={option => option?.label}
      getOptionDisabled={getOptionDisabled}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <Textfield {...params} {...othersProps} />}
    />
  )
}

export default React.memo(InputGroup1)
